/**
 * Shape typed digits like the login form's mask, "+1 (512) 555-0199", so the
 * saved number looks the same whichever screen it came from.
 */
export const formatUsPhone = (raw: string) => {
  let digits = raw.replace(/\D/g, '');
  if (
    raw.trim().startsWith('+1') ||
    (digits.length > 10 && digits[0] === '1')
  ) {
    digits = digits.slice(1);
  }
  digits = digits.slice(0, 10);
  if (!digits) {
    return '';
  }
  const area = digits.slice(0, 3);
  const prefix = digits.slice(3, 6);
  const line = digits.slice(6);
  let out = `+1 (${area}`;
  if (digits.length > 3) out += `) ${prefix}`;
  if (digits.length > 6) out += `-${line}`;
  return out;
};
